import * as yup from "yup";

export const getYupValidationSchema = (validators, extraValidationProps, isValueAnArray) => {
    let schema = isValueAnArray ? yup.array() : yup.string();
    validators.forEach((validator) => {
        if (validator.type === "RequiredValidator" && !isValueAnArray) {
            schema = schema.required(validator.model.message);
        }

        if (validator.type === "RequiredValidator" && isValueAnArray) {
            schema = schema
                .min(1, validator.model.message);
        }

        if (validator.type === "RegularExpressionValidator") {
            schema = schema.matches(new RegExp(validator.model.jsPattern), validator.model.message);
        }

        if (validator.type === "FieldMatchValidator") {
            schema = schema.oneOf([yup.ref(validator.model.matchField)], validator.model.message);
        }

        if (validator.type === "EmailFormatValidator") {
            schema = schema.email(validator.model.message || 'Ugyldig e-mail format');
        }

        if (validator.type === "EmailDomainValidator") {
            schema = schema.test(
                "valid-email-domain",
                validator.model.message || "Ugyldig e-mail domain",
                (value) => {
                    if (!value) return true;
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (!emailRegex.test(value)) return false;

                    const domain = value.split("@")[1];
                    return validator.model.validDomains.includes(domain);
                }
            );
        }

        if (validator.type === "FileSizeValidator") {
            schema = schema.test(
                "valid-total-file-size",
                validator.model.message,
                (files) => {
                    if (!files) return true;
                    const totalSize = files.reduce((acc, file) => acc + file.size, 0);
                    return totalSize <= validator.model.sizeInBytes;
                }
            );
        }

        if (validator.type === "PhoneCountryCodeValidator") {
            schema = schema.test(
                "valid-phone-country-code",
                validator.model.message || "Invalid phone country code",
                (value) => {
                    if (!value) return true;
                    const phoneCountryCodeRegex = /^\+\d{1,5}$/;
                    return phoneCountryCodeRegex.test(value);
                }
            );
        }
        // other validation types
    });

    return schema;
};